// Version : 0.0.1
// Author : SATHISH
// LastEdit : KARTHEESWARAN
// MODFIED DATE:30-09-2025
//Last ADD : REMOVED EXCEL SERVICES

import { makeApiCall } from '../../../_common/api.utils';
import { FIN_API_URL } from '../../../const';

/*************** GET CASH BOOK START *************** */
export const getdaybookListDetails = (listData: any) => {
	const data = {
		GetBranchAccountDayBookToken: listData,
	};
	const url = `${FIN_API_URL}getBranchAccountsDayBook`;
	return makeApiCall(url, data);
};
/*************** GET CASH BOOK END *************** */
